import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import { useSelector } from 'react-redux';
import { selectDocsResponse } from '../../redux-state/selectors';
import { compareFeeLabels } from '../utility/feeItems';

function RefiDocsOutputRightSide() {
  const docsOutput = useSelector(selectDocsResponse);
  const excludedKeys = ['Inputs', 'TransactionID', 'Type', 'Notes'];

  // Sorted by document name, matching utility/generateDocsReport.js and the
  // bot's summary PDF. This list previously followed whatever order ATC
  // returned <Documents> in, so the screen and its own download could disagree.
  const documents = Object.entries(docsOutput || {})
    .filter(([key, value]) => !excludedKeys.includes(key) && Array.isArray(value))
    .sort(([a], [b]) => compareFeeLabels(a, b));

  const nonLinkItems = documents.filter(([, [pdfUrl]]) => !pdfUrl);
  const linkItems = documents.filter(([, [pdfUrl]]) => pdfUrl);
  const notes = docsOutput?.Notes;

  return (
    <div className="flex flex-col w-full space-y-6">
      <div className="flex justify-between items-center">
        <div className="flex flex-row text-gray-700 font-bold items-center h-11">Documents Output</div>
      </div>

      {notes && (
        <div className="bg-white p-6 rounded-xl border text-sm">
          <h3 className="text-gray-800 font-bold mb-4">Notes</h3>
          <ul className="list-disc pl-6 space-y-2 text-gray-700 text-xs">
            {notes.split('|').map((note, index) => (
              <li key={index} dangerouslySetInnerHTML={{ __html: (note?.replaceAll('<a ', '<a target="_blank" ')) }} />
            ))}
          </ul>
        </div>
      )}

      {nonLinkItems.map(([key, [, html]]) => (
        <div key={key} className="bg-white p-6 rounded-xl border text-sm docs-output-form min-w-0">
          <h4 className="font-medium text-gray-800 mb-2 break-words">{key}</h4>
          <ul className="list-disc pl-6 text-xs text-gray-700 sanitizedHtml">
            <div
              className="break-words whitespace-normal max-w-full"
              dangerouslySetInnerHTML={{ __html: (html?.replaceAll('<a ', '<a target="_blank" ')) }}
            />
          </ul>
        </div>
      ))}

      {linkItems.length > 0 && (
        <div className="bg-white p-6 rounded-xl border text-sm space-y-6">
          {linkItems.map(([key, [pdfUrl, html]]) => (
            <div key={key} className="flex justify-between items-start gap-4 border-b pb-4 last:border-0 last:pb-0 docs-output-form">
              <div className="min-w-0 flex-1">
                <h4 className="font-medium text-gray-800 break-words">{key}</h4>
                {html && (
                  <ul className="list-disc pl-4 mt-1 text-xs text-gray-600 sanitizedHtml break-words">
                    <div dangerouslySetInnerHTML={{ __html: (html?.replaceAll('<a ', '<a target="_blank" ')) }} />
                  </ul>
                )}
              </div>
              <a
                href={pdfUrl}
                download
                target="_blank"
                rel="noopener noreferrer"
                className="border border-gray-300 w-8 h-8 flex items-center justify-center rounded-md hover:bg-gray-100 cursor-pointer shrink-0"
              >
                <DownloadOutlinedIcon />
              </a>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
export default RefiDocsOutputRightSide;